export enum ContractClassification {
    Trainee = 1,
    Junior = 2,
    Pleno = 3,
    Senior = 4
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractClassification.ts